import BaseModelRequest from '../communicate/BaseModelRequest'

export default class PostRequest extends BaseModelRequest {

  getModelName () {
    return "articles";
  }

  loadArticles(data) {
    const url = `articles?page=${data.page}&limit=${data.limit}`;
    return this.get(url);
  }

  loadDetailArticle(id) {
    const url = "article/" + id;
    return this.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/request/PostRequest.js